const myAccount = {
  title: {
    customerAccount: 'Customer Account',
    logout: 'Logout',
  },
  userDataContainer: {
    userData: 'User Data',
    edit: 'Edit',
    customerNumber: 'Customer Number',
    changePassword: 'Change Password',
    yourAccount: 'Your Account',
  },
  lastOrders: 'Last Orders',
  noOrders: {
    title: 'Orders',
    neverOrdered: 'You have never placed an order using your IhreApotheken account.',
    usePharmacy: 'Make sure to use your IhreApotheken account when ordering to easily reorder.',
    orderNow: 'Order Now',
  },
  editUserData: {
    updateAccount: 'Update Customer Account',
    updateOrComplete: 'Here you can update or complete your user data.',
    successfullyUpdatedMessage: 'Your contact details have been successfully changed.',
    yourEmail: 'Your Email Address',
    changeEmail: 'Change Email',
    changePassword: 'Change Password',
    changePasswordDescription: 'Would you like to set a new password?',
    dataSharingLabel: 'Data Sharing for Pharmacies',
    dataSharingManagePermissions: 'Manage Permissions',
    deleteAccountQuestion: 'Do you want to completely delete your IhreApotheken.de account? Click here and then check your emails for confirmation.',
    deleteAccount: 'Delete Account',
    deleteAccountEmailSent: 'We have sent an email to your inbox. It contains a link that you must click to permanently delete your IhreApotheken.de account.',
    maxTriesEmail: 'You have reached the maximum number of change attempts. Please contact our customer service',
    here: 'here',
    changeEmailAddress: 'Change Email Address',
    emailChangeNote: 'Here you can change the email address associated with your IhreApotheken.de customer account. Please note that all order notifications will be sent to your new email address.',
    newEmail: 'New Email Address',
    currentPassword: 'Current Password',
    forgotPassword: 'Forgot Password?',
    cancel: 'Back',
    howToChange: 'How to Change Your Email Address:',
    enterEmail: 'Please enter your new email address and confirm it with your current password. Then click "Change Email".',
    receiveVerification: 'You will receive a verification email from us.',
    afterVerify: 'After verifying your new email address, you can log in to your IhreApotheken account.',
    emailSent: 'Email Sent!',
    emailWasSentTo: 'An email was sent to ',
    linkToVerify: ' containing a link you must click to verify your new email address. Please also check your spam folder if necessary.',
    emailChanged: 'Your email address has been successfully changed!',
    youCanRegister: 'You can now log in with ',
    atIa: ' at IhreApotheken.de.',
    toYourPharmacy: 'to your pharmacy',
    deleteAccountTitle: 'Permanently Delete Account?',
    deleteAccountDescription: 'Do you really want to permanently delete your IhreApotheken.de account? If you select “Delete Account,” you will receive an email with a confirmation link.',
    back: 'Back',
    updateHere: 'Here you can update your password.',
    newPassword: 'New Password',
    notice: 'Note: ',
    passwordConstraint: 'The password must be at least 8 characters long and contain 1 uppercase letter, 1 lowercase letter, and 1 number.',
    repeatPassword: 'Confirm New Password',
    update: 'Update',

    form: {
      salutation: 'Salutation',
      firstName: 'First Name',
      lastName: 'Last Name',
      streetName: 'Street',
      houseNumber: 'House Number',
      zipCode: 'ZIP Code',
      cityName: 'City',
      mobileNumber: 'Mobile Number',
      phoneNumber: 'Phone Number',

      fillNecessary: '* Please fill in the required fields',
      ourPromise: '{strongText} We only use the phone number for any inquiries from the pharmacy regarding your pre-orders. You will also be informed about the status of your order via SMS and email.',
      ourPromiseTitle: 'Our Promise:',

      cancel: 'Cancel',
      update: 'Update',

      emailInUse: 'This email address is already linked to an IhreApotheken account.',
      wrongPassword: 'The password is incorrect. Please try again.',
    },
    whatsApp: {
      title: 'WhatsApp Consultation',
      agreement: 'Consent to WhatsApp Communication',
      agreementDescription: 'I agree that my phone number may be used for communication via WhatsApp. I can revoke this consent at any time. I have acknowledged the privacy policy.',
    },
  },
  ordersPage: {
    backToOverview: 'Back to Overview',
    allProducts: 'All Orders',
    prescriptions: 'Prescriptions',
    coPaymentOpen: 'Co-payment Open',
  },
  deleteAccount: {
    title: 'Your Account Has Been Successfully Deleted',
    paragraph: 'We are very sorry that you have deleted your IhreApotheken.de account. We would love to welcome you back to IhreApotheken.de soon.',
    registerNow: 'Register Now',
  },
  addresses: {
    newAddress: 'New Address',
    deliveryAddress: 'Delivery Address',
    paymentAddress: 'Billing Address',
    update: 'Edit',
    delete: 'Delete',
    modalDelete: 'Do you really want to delete this address?',
    no: 'No',
    yes: 'Yes, delete',
    loadMoreDelivery: 'More Delivery Addresses',
    loadMorePayment: 'More Billing Addresses',
  },
  pharmacyInfo: {
    yourSelectedPharmacy: 'Your Selected Pharmacy',
    contactInfo: 'Contact Information',
    email: 'Email Address',
    phoneNumber: 'Phone Number',
    faxNumber: 'Fax Number',
    website: 'Website',
    toWebsite: 'To Website',
    deliveryMethods: 'Delivery Methods',
    expressDelivery: 'Express Courier Delivery',
    regularDelivery: 'Courier Delivery',
    pickup: 'Pickup at the Pharmacy',
    socialMediaText: 'Visit us also on',
    discoverProducts: 'Discover Products',
    onlinePayment: 'Online Payment Available',
    noPharmacySelected: 'No Pharmacy Selected',
  },
  reorder: {
    inStock: 'Available',
    outOfStock: 'Out of Stock',
    oldPrice: 'Old Price',
    singlePrice: 'Single Price',
    totalPrice: 'Total Price',
    total: 'Total',
    vat: '(incl. VAT)',
    findPharmaciesMessage: 'Find pharmacies with all products',
  },
  epaper: {
    title: 'E-Paper Subscription',
    description: 'Your my life E-Paper subscription is active. Click the "To Magazine" button to go directly to the current issue of my life as an e-paper. Under "E-Paper Overview" you will also find previous editions of my life.',
    unsubscribedDescription: 'All my life magazines are now also available as e-papers. Stay well-informed anytime, anywhere!',
    toMagazine: 'To Magazine',
    toEpaperOverview: 'E-Paper Overview',
    subscribe: 'Subscribe for Free',
    unsubscribe: 'Cancel Subscription',
  },
  cart: {
    title: 'Your Cart',
    info: {
      mixedCart: 'You still have {productsCount} {product} and {prescriptionCount} {prescription} in your cart',
      onlyRegularProducts: 'You still have {productsCount} {product} in your cart',
      onlyPrescriptions: 'You still have {prescriptionCount} {prescription} in your cart',
    },
    description: 'Please note that your cart will be emptied automatically if you switch pharmacies or log out of your account!',
    cartType: {
      product: 'Product',
      products: 'Products',
      prescription: 'Prescription',
      prescriptions: 'Prescriptions',
    },
  },
  dataSharingPage: {
    title: 'Data Sharing for Pharmacies',
    description: 'Pharmacies with which you actively interact—such as by pre-ordering products, redeeming prescriptions, or booking appointments—will have access to your master data and associated pre-orders, prescriptions, and appointments. This access ensures that pharmacists have all the necessary information to best assist you during your visit. You can revoke this permission at any time. If you place another order with the pharmacy after revocation, access will be automatically restored so your order can be processed.',
    lastOrderLabel: 'Last Order',
    isGrantedToggle: 'Data Sharing Granted',
    removePharmacy: 'Remove Pharmacy',
    noPharmacies: 'No pharmacies have access to your data.',
    modalRemovePharmacy: {
      title: 'Do you want to remove the pharmacy from your profile?',
      description: 'The pharmacy can be re-added later if needed.',
      confirm: 'Remove Pharmacy',
      cancel: 'Zurück',
    },
    button: 'Go to Cart',
  },
  confirmDataSharingPage: {
    error: {
      title: 'The link has unfortunately expired',
      description: 'Please contact your pharmacy to reconnect with your account.',
    },
    success: {
      title: 'Your customer data has been shared!',
      description: 'Your pharmacy can now advise you in the best possible way regarding your health.',
    },
    buttons: {
      goToStartpage: 'Back to the homepage',
      goToDataSharing: 'To data sharing',
    },
  },
}

export default myAccount
